// extracted by mini-css-extract-plugin
module.exports = {"EmpProfileInfoWrapper":"EmpProfileInfo__EmpProfileInfoWrapper___1QorG"};